import { Intervention } from '@/types';
import { noop } from 'lodash/fp';
import { Container, Frame, Content, Stack } from '@kinesis/bungle';
import { Layout } from '@/components/layout';
import { InterventionDetail } from '@/components/intervention-detail';

const InterventionEdit = (props: InterventionEditProps) => {
  const { intervention, onUpdate = noop } = props;

  return (
    <Content padding='none' height='100%'>
      <Container>
        <Frame sizing='fill-container'>
          <Layout>
            <Stack space='large'>
              <InterventionDetail
                intervention={intervention}
                onUpdate={onUpdate}
              />
            </Stack>
          </Layout>
        </Frame>
      </Container>
    </Content>
  );
};

export type InterventionEditProps = {
  intervention: Intervention;
  onUpdate?: (f: (x: Intervention) => Intervention) => void;
};

export { InterventionEdit };
